/**
 * filterLinksByType
 * @param {array} selectedTypes - list of selectedTypes to be matched against
 * @param {array} links - list of links data
 * @returns {array} filtered list of links data based on types
 */
export const filterLinksByType = (selectedTypes, links) => {
  if (!selectedTypes.length) {
    return links;
  }

  return links?.filter((link) => {
    const currentLinkType = link.linkType;

    if (!currentLinkType) {
      return false;
    }

    return selectedTypes.includes(currentLinkType);
  });
};
